import rootMapper from './mappers/pdp/rootMapper';

const rootReducer = (state, action) =>
  action?.type && typeof rootMapper?.[action.type] === 'function' ? rootMapper?.[action.type](state, action) : state;

export default rootReducer;
